import { useQuery } from '@tanstack/react-query';

type MeetingNoteAudioSegment = {
  id: number;
  startSeconds: number;
  endSeconds: number;
  speaker: string;
};

type MeetingNoteAudio = {
  url: string;
  segments: MeetingNoteAudioSegment[];
};

/** Recording URL + per-segment timing for a meeting note, used to play verify evidence. */
export function useMeetingNoteAudio(meetingNoteId: string | undefined) {
  return useQuery<MeetingNoteAudio>({
    queryKey: ['meeting-notes', meetingNoteId, 'audio'],
    enabled: !!meetingNoteId,
  });
}
